import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  Validators,
  NonNullableFormBuilder,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export interface SingleTextInputData {
  title: string;
  label: string;
  buttonText: string;
  text: string;
  background: boolean;
  required: boolean;
}

@Component({
  selector: 'thred-single-text-input-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressBarModule,
  ],
  templateUrl: './single-text-input-dialog.component.html',
  styleUrls: ['./single-text-input-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleTextInputDialogComponent {
  readonly fg = this.fb.group({
    value: [this.data.text ?? '', Validators.required],
  });

  constructor(
    private fb: NonNullableFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: SingleTextInputData,
    private dialogRef: MatDialogRef<SingleTextInputDialogComponent, string>,
  ) {
    if (!data.required) {
      this.fg.controls.value.removeValidators(Validators.required);
    }
  }

  onSubmit() {
    if (this.fg.invalid) {
      return;
    } else {
      this.dialogRef.close(this.fg.getRawValue().value);
    }
  }
}
